import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const getDisputes = (
  {
    currentPage,
    pageSize,
    params = {}
  }
    : {
      currentPage: number,
      pageSize: number,
      isLive: boolean,
      params: Record<string, string | number | boolean>
    }
) => {

  const queryParams = {
    page: currentPage,
    page_size: pageSize,
    ...params
  };

  return axiosPrivate.get(`/dashboard/api/v1/disputes`, { params: queryParams });
};